import { useSiteContent } from '@/hooks/useSiteContent';
import { useTranslation } from 'react-i18next';
import ContentState from '@/components/feature/ContentState';

interface ValueProp {
  icon: string;
  title: string;
  description: string;
}

export default function WhyChooseUs() {
  const { data, loading, error, refresh } = useSiteContent<ValueProp[]>('about_value_props');
  const { t } = useTranslation();

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-white py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-accent-500 font-body text-sm tracking-wide uppercase mb-2">{t('about.whyEyebrow')}</p>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-secondary-900 leading-tight">
            {t('about.whyTitleA')} <span className="text-accent-500">{t('about.whyTitleB')}</span>
          </h2>
          <p className="text-secondary-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
            {t('about.whySubtitle')}
          </p>
        </div>

        {/* Grid of Value Props */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {data.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-xl p-5 md:p-6 border border-secondary-100 hover:border-accent-200 transition-colors group"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-50 flex items-center justify-center mb-4 group-hover:bg-accent-100 transition-colors">
                <i className={`${item.icon} text-accent-500 text-lg`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-secondary-900 mb-2">
                {item.title}
              </h3>
              <p className="text-secondary-500 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}